module.exports = __webpack_public_path__ + "static/thaw-settings-bg-aa151c78dc99d239d14070caa4bc8cab.png";